export default defineAppConfig({
  ui: {
    colors: {
      primary: "app-primary",
      secondary: "app-secondary",
    },
    button: {
      compoundVariants: [
        {
          color: "secondary",
          class: "text-nutral-900 dark:text-white",
        },
        {
          color: "primary",
          class: "dark:text-white",
        },
      ],
    },
    navigationMenu: {
      slots: {
        linkLeadingIcon: "text-white dark:text-white",
      },
      variants: {
        active: {
          false: {
            link: "text-white",
          },
          true: {
            link: "dark:text-white",
          },
        },
      },
    },
    drawer: {
      slots: {
        container: "bg-primary-700",
      },
    },
  },
});
